import { useKeyPressEvent } from "react-use";
import type SequencerUIState from "../../model/control/SequencerUIState";

export function useKeyActionMapper(state: SequencerUIState) {
  useKeyPressEvent(
    (event: KeyboardEvent) => state.hasKeyAction(event.key),
    (event: KeyboardEvent) => state.runKeyAction(event.key)
  );
}
